import { SVGProps } from 'react';

export { Path as StylovyzePath } from '../Icons.styles';
export { StrokePath as StylovyzeStrokePath } from '../Icons.styles';

export interface StylovyzeIconProps extends SVGProps<SVGSVGElement> {
	color?: string;
}

export type StylovyzeIcon = React.FC<StylovyzeIconProps>;
